import { useRef, forwardRef, useState } from "react";

import {
  Dialog,
  Typography,
  Stack,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import FullPlayAnimationTimeline from "../../playcreator/components/FullPlayAnimationTimelineV2.js";
import QuillDisplay from "../../components/QuillDisplay";
import Helper from "../../playcreator/functions/Helper.js";
import FullPlayAnimator from "./FullPlayAnimator.js";
import useMediaQuery from "@mui/material/useMediaQuery";
import Iconify from "../../components/Iconify";
import FullScreenPhase from "./FullScreenPhase.js";
import Slide from "@mui/material/Slide";
import Fade from "@mui/material/Fade";

const Transition = forwardRef(function Transition(props, ref) {
  if (props.transition === "slide") {
    return <Slide direction="up" ref={ref} {...props} />;
  }
  return <Fade ref={ref} {...props} />;
});

export default function AnimationDialog({
  transition = "fade",
  skipScrollRef = { current: false },
  ...props
}) {
  let { play } = props;
  let phases = play.data.phases.phases;
  const under600px = useMediaQuery("(max-width:600px)");
  const fullScreenPhaseRef = useRef(null);
  const [mirror, setMirror] = useState(false);

  return (
    <>
      <Dialog
        TransitionComponent={Transition}
        sx={{
          "& .MuiBackdrop-root.MuiBackdrop-backdrop": {
            backgroundColor: "transparent",
          },
          "& .MuiBackdrop-backdrop": {
            backgroundColor: "transparent",
          },
          "& .MuiDialog-container": { alignItems: "flex-start" },
          "& .MuiDialog-paper": { maxWidth: "min(600px,60vh)" },
        }}
        TransitionProps={{ transition }}
        fullWidth={true}
        fullScreen={under600px}
        maxWidth={"sm"}
        open={props.open}
        onClose={props.close}
      >
        {under600px && (
          <Stack
            sx={{ pl: 3 }}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {play.title}
            </Typography>

            <Tooltip title="Close">
              <IconButton
                color="inherit"
                sx={{ "&:hover": { color: "initial" } }}
                onClick={props.close}
              >
                <Iconify sx={{ fontSize: 40 }} icon={"eva:close-fill"} />
              </IconButton>
            </Tooltip>
          </Stack>
        )}

        {play && (
          <FullScreenPhase
            showFullPlay={true}
            phases={phases}
            mirror={mirror}
            setMirror={setMirror}
            settings={play.data.settings}
            ref={fullScreenPhaseRef}
          />
        )}

        <FullPlayAnimator
          mirror={mirror}
          prefix={"dialog_"}
          showTitle={false}
          title={""}
          data={play.data}
        />
        <Box sx={{ px: 3 }}>
          <FullPlayAnimationTimeline
            requestFullscreen={() => {
              skipScrollRef.current = true;
              fullScreenPhaseRef.current?.requestFullscreen();
            }}
            mirror={mirror}
            setMirror={setMirror}
            showOverlay={play.data.settings?.showOverlay ?? true}
            updateSteps={() => {}}
            prefix={"dialog_"}
            phases={phases}
            editor={play.data.settings.editor}
          />
        </Box>

        <Box sx={{ px: 3, pb: 4 }}>
          <Box sx={{ minHeight: 100 }}>
            {phases.map((phase, index) => (
              <Box
                key={phase.id}
                sx={{
                  pt: 2,
                  display: index === 0 ? "block" : "none",
                }}
                id={"dialog_phase_note_" + +phase.id}
              >
                <Box sx={{ fontWeight: 600 }}>
                  {Helper.getPhaseTitle(phase, phases, "output")}
                </Box>
                <QuillDisplay content={phase.note} />
              </Box>
            ))}
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
